import { toast } from "sonner";
import { toSafeMessage } from "@/lib/safeMessage";

let installed = false;

function wrapToastMethod(name) {
  const original = toast[name];
  if (typeof original !== "function") return;
  if (original.__obihub_safe_wrapped) return;

  const wrapped = (message, ...rest) => original(toSafeMessage(message), ...rest);
  wrapped.__obihub_safe_wrapped = true;
  toast[name] = wrapped;
}

export function installSafeToast() {
  if (installed) return;
  installed = true;

  ["error", "success", "info", "warning", "message", "loading"].forEach(wrapToastMethod);
}

